/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */
const menuInit = () => {
  const dropdowns: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.menu .menu__item--has-children',
  );
  const active: string = 'menu__item--active';

  const closeDropdowns = () => {
    dropdowns.forEach((dropdown: HTMLElement) => {
      dropdown.classList.remove(active);
    });
  };

  dropdowns.forEach((dropdown: HTMLElement) => {
    const children: NodeListOf<HTMLElement> = dropdown.querySelectorAll('.menu__link');

    children.forEach((child: HTMLElement) => {
      child.addEventListener('click', (e: Event) => {
        e.preventDefault();
        e.stopPropagation();

        // Remove active classes from all items
        closeDropdowns();

        // Add active class to current click
        dropdown.classList.add(active);
      });
    });
  });

  // Remove active class of all dropdown parents
  // when clicked anywhere in document
  document.addEventListener('click', () => closeDropdowns);
};

export default menuInit;
